import { useContext } from "react";
import { GlobalInfo } from "../Contexts/GlobalContext";
import { Route, Routes } from "react-router-dom";
import TermsOfUse from "../Pages/Policies/TermsOfUse";
import PrivacyPolicy from "../Pages/Policies/PrivacyPolicy";

const PoliciesRoute = () => {

const { isSidebarVisible } = useContext(GlobalInfo);
const { isRestrictedPage  } = useContext(GlobalInfo);

    return (
        <div className={`${!isRestrictedPage ? 'el-middle' : ''} ${!isSidebarVisible ? 'collapsed-body' : ''}`}>
            <Routes>
                 <Route path="donorx-llc" element={<PrivacyPolicy/>} />
                 <Route path="term-of-use" element={<TermsOfUse />} />
            </Routes>
        </div>
    );
}
export default PoliciesRoute;